export default "__VITE_ASSET__C5TnTIad__"